
import Cookies from 'js-cookie';
// Cookies.defaults = {
//   path: '/',
//   secure: true
// };
if (Cookies.get) {
  let map = {
    "user_name": "a"
  };
  let old_get = Cookies.get;
  Cookies.get = function (key) {
    if (map[key]) {
      return old_get.call(this, key) || old_get.call(this, map[key]) || "";
    }
    return old_get.call(this, key);
  };
}
export default Cookies;